import { Button, Col, Form, Input, Row, Select } from "antd";
import PropTypes from "prop-types";
import React from "react";

const { Option } = Select;
const ShortUrlSearch = ({ onSearch, onReset, courses, form }) => {

  return (
    <Form form={form} onFinish={onSearch}>
      <Row gutter={16}>
        <Col>
        <Form.Item
            name="urlCode"
            label="Search By Short Code"
            required
          >
            <Input placeholder="Short Code" />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Form.Item>
          <Button type="primary" htmlType="submit">
            Search
          </Button>
          <Button htmlType="button" onClick={onReset}>
            Reset
          </Button>
        </Form.Item>
      </Row>
    </Form>
  );
};

ShortUrlSearch.propTypes = {
  onSearch: PropTypes.func,
  onReset: PropTypes.func,
  courses: PropTypes.array.isRequired,
};

export default ShortUrlSearch;
